import { memo } from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormField, TextField, VStack } from '@library';
import { validateEmail } from '../../../../core/util/validators';
import styles from './ContactInformation.module.scss';

const RequiredField = memo(
    ({
        labelId,
        placeholderId,
        name,
    }: {
        name: string;
        labelId: string;
        placeholderId: string;
    }) => {
        const intl = useIntl();

        return (
            <Controller
                name={name}
                render={({ field, fieldState: { error } }) => (
                    <FormField
                        label={intl.formatMessage({ id: labelId })}
                        error={
                            error?.message && (
                                <FormattedMessage id={error.message} />
                            )
                        }
                    >
                        <TextField
                            disabled={field.disabled}
                            placeholder={intl.formatMessage({
                                id: placeholderId,
                            })}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    </FormField>
                )}
                rules={{ required: 'this field is required' }}
            />
        );
    }
);

const ContactInformation = () => {
    const intl = useIntl();

    return (
        <VStack gap="small" className={styles.container}>
            <RequiredField
                name="customerNumber"
                labelId="customer no."
                placeholderId="customer number"
            />

            <RequiredField
                name="name"
                labelId="name"
                placeholderId="your name"
            />

            <Controller
                name="email"
                render={({ field, fieldState: { error } }) => (
                    <FormField
                        label={intl.formatMessage({ id: 'email' })}
                        error={
                            error?.message && (
                                <FormattedMessage id={error.message} />
                            )
                        }
                    >
                        <TextField
                            disabled={field.disabled}
                            placeholder={intl.formatMessage({
                                id: 'your email',
                            })}
                            type="email"
                            value={field.value}
                            onChange={field.onChange}
                        />
                    </FormField>
                )}
                rules={{
                    required: 'this field is required',
                    validate: (email: string) => {
                        const isValid = validateEmail(email);
                        return !isValid ? 'must be valid email' : true;
                    },
                }}
            />
        </VStack>
    );
};

export default memo(ContactInformation);
